/* ============================================================
   DNI · Catálogo — interacción mínima del lado del cliente
   (port de lo que en dni-catalog.jsx era estado de React)
   - Abrir/cerrar los desplegables de filtros (.dd)
   - Toggle de vista grilla / compacta (.prod-grid.compact) con memoria
   El FILTRADO en sí lo hace Shopify del lado del servidor (los <a> de cada
   valor navegan a la URL filtrada); esto es solo la capa visual.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Desplegables (.dd) ---------- */
  var dds = document.querySelectorAll('[data-dd]');

  function closeAll(except) {
    dds.forEach(function (dd) {
      if (dd === except) return;
      var menu = dd.querySelector('[data-dd-menu]');
      var btn = dd.querySelector('[data-dd-btn]');
      if (menu) menu.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  dds.forEach(function (dd) {
    var btn = dd.querySelector('[data-dd-btn]');
    var menu = dd.querySelector('[data-dd-menu]');
    if (!btn || !menu) return;
    // clics dentro del menú (slider de precio, etc.) no deben cerrarlo
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = menu.hidden;
      closeAll(dd);
      menu.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  // cerrar al hacer clic fuera o con Escape
  document.addEventListener('click', function () { closeAll(null); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* ---------- Vista grilla / compacta ---------- */
  var grid = document.querySelector('[data-prod-grid]');
  var toggle = document.querySelector('[data-view-toggle]');
  var KEY = 'dni-cat-view';

  function applyView(view) {
    if (!grid) return;
    grid.classList.toggle('compact', view === 'compact');
    if (toggle) {
      toggle.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-view') === view);
      });
    }
  }

  if (toggle && grid) {
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved) applyView(saved);

    toggle.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-view]');
      if (!b) return;
      var view = b.getAttribute('data-view');
      applyView(view);
      try { localStorage.setItem(KEY, view); } catch (e) {}
    });
  }

  /* ---------- Slider de precio (línea de menos a más) ---------- */
  var priceEl = document.querySelector('[data-price]');
  if (priceEl) {
    var minName = priceEl.getAttribute('data-min-name');
    var maxName = priceEl.getAttribute('data-max-name');
    var rawCeil = parseInt(priceEl.getAttribute('data-ceil-raw'), 10) || 0;
    // range_max viene en centavos → pasar a pesos y redondear a un tope "cerrado"
    var majorCeil = Math.round(rawCeil / 100);
    var niceCeil = function (n) {
      if (n <= 0) return 1000;
      var step = n > 200000 ? 25000 : n > 50000 ? 10000 : n > 10000 ? 5000 : 1000;
      return Math.ceil(n / step) * step;
    };
    var floor = 0;
    var ceil = niceCeil(majorCeil);
    var step = ceil > 100000 ? 5000 : ceil > 20000 ? 1000 : 500;

    var rmin = priceEl.querySelector('[data-price-min]');
    var rmax = priceEl.querySelector('[data-price-max]');
    var lo = priceEl.querySelector('[data-price-lo]');
    var hi = priceEl.querySelector('[data-price-hi]');
    var fill = priceEl.querySelector('[data-price-fill]');
    var apply = priceEl.querySelector('[data-price-apply]');

    if (ceil > floor && rmin && rmax) {
      var params0 = new URLSearchParams(window.location.search);
      var curMin = parseInt(params0.get(minName), 10);
      var curMax = parseInt(params0.get(maxName), 10);

      [rmin, rmax].forEach(function (r) { r.min = floor; r.max = ceil; r.step = step; });
      rmin.value = isNaN(curMin) ? floor : Math.max(floor, curMin);
      rmax.value = isNaN(curMax) ? ceil : Math.min(ceil, curMax);

      var fmt = function (n) { return '$' + Number(n).toLocaleString('es-CL'); };
      var paint = function () {
        var a = Math.min(+rmin.value, +rmax.value);
        var b = Math.max(+rmin.value, +rmax.value);
        if (lo) lo.textContent = fmt(a);
        if (hi) hi.textContent = fmt(b) + (b >= ceil ? '+' : '');
        if (fill) {
          fill.style.left = ((a - floor) / (ceil - floor)) * 100 + '%';
          fill.style.right = (100 - ((b - floor) / (ceil - floor)) * 100) + '%';
        }
      };
      rmin.addEventListener('input', function () { if (+rmin.value > +rmax.value) rmin.value = rmax.value; paint(); });
      rmax.addEventListener('input', function () { if (+rmax.value < +rmin.value) rmax.value = rmin.value; paint(); });
      paint();

      // estado activo en el botón "Precio"
      var btn = document.querySelector('[data-price-btn]');
      if (btn && (params0.get(minName) || params0.get(maxName))) {
        btn.classList.add('active');
        var val = document.createElement('span');
        val.className = 'dd-val';
        val.textContent = fmt(+rmin.value) + ' – ' + fmt(+rmax.value);
        btn.insertBefore(val, btn.querySelector('svg'));
      }

      if (apply) apply.addEventListener('click', function () {
        var a = Math.min(+rmin.value, +rmax.value);
        var b = Math.max(+rmin.value, +rmax.value);
        var params = new URLSearchParams(window.location.search);
        params.delete(minName); params.delete(maxName);
        if (a > floor) params.set(minName, a);
        if (b < ceil) params.set(maxName, b);
        var qs = params.toString();
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    }
  }
})();
